// src/components/Accordion.jsx
import { useState } from "react";
import styles from "./accordion.module.css";
import IMAGES from "../../assets/images/images";
import { TYPE } from "../../utils/constants/DemandConstant";

export default function Accordion({ accordianType, title, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`${accordianType===TYPE.PARENT?styles.parentaccordian:styles.accordion} ${open?styles.opendparentaccordian:""}`}>
      {accordianType===TYPE.PARENT?
      <div
        className={`${open?styles.parentaccordionHeader: styles.closedparentaccordionHeader} ${open ? styles.open : ""}`}
        aria-expanded={open}
      >
        <span>{title}</span>
        <span className={styles.caret} onClick={() => setOpen(!open)} >
          <img className={`${styles.downchevron} ${open?styles.opencheveron:""}`} src={IMAGES.downchevron} alt="arrow" />
        </span>
      </div>
      :
      <button
        type="button"
        className={`${styles.accordionHeader} ${open ? styles.open : ""}`}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span>{title}</span>
        {/* <span className={styles.caret}>{open ? "▾" : "▸"}</span> */}
        <img className={`${styles.downchevron} ${open?styles.opencheveron:""}`} src={IMAGES.arrowdown} alt="arrow" />
      </button>}

      {open && <div className={accordianType===TYPE.PARENT?"":styles.accordionBody}>{children}</div>}
    </div>
  );
}